import React from 'react'

const DashboardIcon = ({active}) => {
    return (
        <svg width="26" height="21" viewBox="0 0 26 21" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M12.9999 0.000310305C5.83031 0.000310305 0 6.04332 0 13.4749C0 16.2577 0.828666 18.851 2.2278 21L3.53827 19.927C2.36468 18.0772 1.67755 15.8587 1.67755 13.4746C1.67755 6.98282 6.73686 1.73866 13 1.73866C19.2631 1.73866 24.3225 6.98274 24.3225 13.4746C24.3225 15.8587 23.6353 18.0772 22.4614 19.9267L23.7719 20.9997C25.1713 18.8506 26 16.2573 26 13.4746C26 6.04324 20.1696 0 13.0001 0L12.9999 0.000310305ZM20.4172 8.39478L12.9607 13.9097C12.4362 13.9194 11.9193 14.1331 11.5192 14.5482C10.7004 15.3969 10.7004 16.7691 11.5192 17.6181C12.338 18.4668 13.6618 18.4668 14.4809 17.6181C14.8811 17.2033 15.0879 16.6676 15.0969 16.124L20.4175 8.39514L20.4172 8.39478Z" fill={active? "white" :"black"} />
        </svg>
    )
}
export default DashboardIcon;
